import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { onAuthStateChanged } from "firebase/auth";
import { useSetAtom } from "jotai";
import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router";

import { auth } from "../auth";
import { routes } from "../config";
import { userAtom } from "../store";

import { NavigationMenu } from "./NavigationMenu";

export const App = () => {
  const [initialized, setInitialized] = useState(false);
  const setUser = useSetAtom(userAtom);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
        navigate("/login");
      }
      setInitialized(true);
    });

    return () => unsubscribe();
  }, []);

  return (
    <Stack alignItems="center">
      <NavigationMenu />
      {!initialized ? (
        <Typography>Loading...</Typography>
      ) : (
        <Stack sx={{ maxWidth: 600 }}>
          <Routes>
            {routes.map(({ name, path, Component, props = {} }) => {
              return (
                <Route
                  key={name}
                  path={path}
                  // key={name} fixes /:id => /new navigation state not resetting.
                  // @ts-expect-error - Generic components in route config make typing impossible here.
                  element={<Component key={name} {...props} />}
                />
              );
            })}
          </Routes>
        </Stack>
      )}
    </Stack>
  );
};
